import type { CandidateEvent } from '../model/types';

export type CandidateSort = 'match' | 'volume' | 'end';

function endMs(event: CandidateEvent): number {
    return event.endDate?.getTime() ?? Number.POSITIVE_INFINITY;
}

export function sortCandidates(
    events: readonly CandidateEvent[],
    sort: CandidateSort
): CandidateEvent[] {
    const list = [...events];
    if (sort === 'volume') list.sort((a, b) => b.volume - a.volume);
    else if (sort === 'end') list.sort((a, b) => endMs(a) - endMs(b));
    else list.sort((a, b) => b.score - a.score);
    return list;
}

export function visibleCandidates(
    events: readonly CandidateEvent[],
    showClosed: boolean,
    selectedKeys: ReadonlySet<string>,
    keyOf: (event: CandidateEvent) => string
): CandidateEvent[] {
    return events.filter(
        e => e.open || showClosed || selectedKeys.has(keyOf(e))
    );
}
